// @flow
import { add, format, parse } from 'date-fns';

export const dateFormat = 'dd-MM-yyyy';
const dateTimeFormat = 'dd-MM-yyyy HH:mm';

const doParse = (raw: ?any, format: string): ?Date => {
  if (raw) {
    if (typeof raw === 'string') {
      return parse(raw, format, new Date());
    }
  }
  return null;
};

/**
 * Parse date string
 * @param raw date string
 * @returns {null|Date} date value or null if parse fail
 */
export const parseDate = (raw: ?any): ?Date => doParse(raw, dateFormat);

/**
 * Parse date time string
 * @param raw date time string
 * @returns {null|Date} date value or null if parse fail
 */
export const parseDateTime = (raw: ?any): ?Date => doParse(raw, dateTimeFormat);

/**
 * Format date value
 * @param value date value
 * @returns {string} date formatted or empty if date is null
 */
export const formatDate = (value: ?Date): string => {
  if (value) {
    return format(value, dateFormat);
  }
  return '';
};

/**
 * Add years to date value
 * @param value date
 * @param years years to add (subtract if negative)
 * @returns {Date} date with years modified
 */
export const addYearsToDate = (value: Date, years: number): Date => add(value, { years });

export const formatHHMMSS = (ms) => {
  if (isNaN(ms)) return '00:00:00';

  // Nunca permitir negativos
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));

  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, '0');

  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, '0');

  const seconds = Math.floor(totalSeconds % 60)
    .toString()
    .padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};
